import { getMerchantBestSellers } from 'services/api/merchants/best-sellers/get-merchant-best-sellers';

export const fetchMerchantBestSellers = async () => {
  const bestSellers = await getMerchantBestSellers(20);

  return bestSellers;
};
